import { Stack } from '@mui/material';
import { Link } from 'react-router-dom';

import { Button } from 'modules/common/components/Button';
import { BlurredBox } from 'modules/common/components/BlurredBox';
import { withdrawalRouteConfig } from 'modules/withdrawal';
import { DepositDisclaimer } from './DepositDisclaimer';

export function DepositClosedBanner(): JSX.Element {
  return (
    <BlurredBox
      mt={3}
      sx={{
        pb: 2,
        px: 3,
        borderRadius: 2,
      }}
    >
      <Stack gap={2}>
        <DepositDisclaimer />
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          size="large"
          component={Link}
          to={withdrawalRouteConfig.main.generatePath()}
        >
          Go to withdrawals
        </Button>
      </Stack>
    </BlurredBox>
  );
}

